import * as React from "react";
import styled, { css } from "styled-components";
import { select } from "@hubper/theme";
import { Text, Icon } from "..";

const Base = styled.div<{ disabled?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${select.space(1)};
  margin-left: ${select.space(0)};
  cursor: pointer;

  ${p =>
    p.disabled &&
    css`
      opacity: 0.5;
      cursor: default;
    `};
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  text: string;
  onClick: () => void;
  disabled?: boolean;
};

function CloseButton(
  { style, className, text, disabled, onClick }: Props,
  ref: any
) {
  return (
    <Base
      ref={ref}
      style={style}
      className={className}
      disabled={disabled}
      onClick={onClick}
    >
      {text && (
        <Text style={{ marginRight: 2 }} fs={-1}>
          {text}
        </Text>
      )}
      <Icon name="close" size={18} c={["grey", 5]} />
    </Base>
  );
}

export default React.forwardRef(CloseButton);
